
















import { Vue, Component, Watch } from "vue-property-decorator";
@Component({})
export default class Breadcrumb extends Vue {
    data: any = {
        breadcrumbData: [
            {
                routeName: "home",
                routeContent: "首页"
            }
        ]
    };

    @Watch("$route")
    routeChange(to: any, from: any) {
        this.setBreadcrumb(to);
    }

    setBreadcrumb(route: any) {
        let arry: any;
        if (route.meta.faterRoute) {
            (this as any).$router.options.routes.some((item: any) => {
                if (item.name == "container") {
                    item.children.some((_item: any) => {
                        if (_item.name == route.meta.faterRoute) {
                            arry = [
                                {
                                    routeName: _item.name,
                                    routeContent: _item.meta.content
                                },
                                {
                                    routeName: route.name,
                                    routeContent: route.meta.content
                                }
                            ];
                        }
                    });
                }
            });
            this.data.breadcrumbData = this.data.breadcrumbData.concat(arry);
        } else {
            arry = [
                { routeName: route.name, routeContent: route.meta.content }
            ];
            this.data.breadcrumbData = this.data.breadcrumbData.concat(arry);
        }
        // console.log(this.data.breadcrumbData);
    }

    // created() {}
    // mounted() {}
    activated() {
        this.data.breadcrumbData = [
            {
                routeName: "home",
                routeContent: "首页"
            }
        ];
        console.log(this.data.breadcrumbData);
        this.setBreadcrumb(this.$route);
        // console.log(this.$router.options.routes)
    }
}
